import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'timeOrDate'})
export class TimeOrDatePipe implements PipeTransform {

  transform(dateValue: any, time?: boolean): string {
    let date = moment(dateValue);
    if (!date.isValid) {return ''};
    let now = moment();
    let yesterday = moment().subtract(1,'day');
    let tomorrow = moment().add(1,'day');

    let string: string;
    if (date >= now.startOf('day') && date <= now.endOf('day')) {
      string = "Today";
    } else if (date >= yesterday.startOf('day') && date <= yesterday.endOf('day')) {
      string = "Yesterday";
    } else if (date >= tomorrow.startOf('day') && date <= tomorrow.endOf('day')) {
      string = "Tomorrow";
    } else if (date >= now.startOf('year') && date <= now.endOf('year')) {
      string = date.format("MMM D");
    } else {
      string = date.format("MMM D, YYYY");
    }

    if ((string === "Today" && time !== false) || time === true) {
      string += ", " + date.format("h:mm A")
    }
    return string;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/time-or-date.pipe.ts